export const userRootPages = [
  {
    path: '/user',
    children: [
      {
        path: ':userId',
        component: () => import('@/views/user/TheUserViewPage.vue'),
        name: 'user_view_route',
        props: true
      }
    ]
  }
]
